"use strict";
exports.__esModule = true;
exports.Tooltip = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@material-ui/core");
var react_1 = tslib_1.__importDefault(require("react"));
var useStylesLight = core_1.makeStyles(function () { return ({
    arrow: {
        color: '#ffffff'
    },
    tooltip: {
        backgroundColor: '#ffffff',
        boxShadow: '0px 2px 2px rgba(89, 103, 117, 0.2)',
        color: '#000000'
    }
}); });
function Tooltip(props) {
    var children = props.children, _a = props.mode, mode = _a === void 0 ? 'dark' : _a, rest = tslib_1.__rest(props, ["children", "mode"]);
    var classes = useStylesLight();
    return (react_1["default"].createElement(core_1.Tooltip, tslib_1.__assign({ classes: mode === 'light' ? classes : undefined }, rest), children));
}
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map